import { BaseApp } from "./index";

export default class AppHeader
{
    private app: BaseApp;
    private container: HTMLElement;
    private title: HTMLElement;
    private icon: HTMLElement;

    public defaultIconClass = 'im im-file-text';
    public defaultText = '';

    public set text(text: string)
    {
        this.title.innerHTML = text;
    }

    public set iconClass(classNames: string)
    {
        this.icon.className = `icon ${classNames}`;
    }

    constructor(app: BaseApp)
    {
        this.app = app;

        this.container = <HTMLElement>document.querySelector('[data-view-header-container]');
        this.title = <HTMLElement>this.container.querySelector('.title');
        this.icon = <HTMLElement>this.container.querySelector('.icon');
    }

    public setVisibility(visible: boolean)
    {
        this.container.style.display = visible ? 'block' : 'hidden';
    }

    public reset()
    {
        this.text = this.defaultText;
        this.iconClass = this.defaultIconClass;
    }
}